/* eslint-disable jsx-a11y/anchor-is-valid */
import type { FC } from "react";

export interface SimpleListItem {
  id?: string;
  title: string;
  value: string | number | React.ReactNode;
  redirectPath?: string;
  onClick?: () => void;
}

export interface SimpleListProp {
  items: SimpleListItem[];
  variant?: "default" | "compact";
}

export const SimpleList: FC<SimpleListProp> = (props) => {
  const isCompact = props.variant === "compact";

  return (
    <ul className="w-full divide-y divide-border dark:text-text">
      {props.items.map((item) => {
        return (
          <div
            key={item.id ?? item.title}
            className={`${isCompact ? "px-4 py-3" : "py-4 px-4 sm:px-6"}`}
          >
            <div className="grid grid-cols-2 justify-between gap-4">
              <p className={`${isCompact ? "text-sm" : ""} text-muted`}>
                {item.title}
              </p>
              {item.redirectPath && (
                <div className={`${isCompact ? "text-sm" : ""} text-end`}>
                  <a
                    href={item.redirectPath}
                    onClick={(e) => {
                      if (item.onClick) {
                        e.preventDefault();
                        item.onClick();
                      }
                    }}
                    className="underline text-purple-600 hover:text-purple-700 visited:text-purple-800 dark:text-purple-400 dark:hover:text-purple-300 dark:visited:text-purple-300"
                  >
                    {item.value}
                  </a>
                </div>
              )}
              {!item.redirectPath && (
                <p
                  className={`${isCompact ? "text-sm" : ""} text-end font-medium text-text break-words`}
                >
                  {item.value}
                </p>
              )}
            </div>
          </div>
        );
      })}
    </ul>
  );
};
